export default "__VITE_ASSET__D0tQ1mbT__"